import React from "react";
import AppRouter from "./Routes/AppRouter/AppRouter";

function App() {
  return (
    <div className="App">
      <AppRouter/>
    </div>
  );
}

export default App;
